export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-background-50 font-heading text-lg font-semibold">
                91在线视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-xs">
              精选高分热门推荐在线观看平台。汇聚海量<strong className="text-background-300">精品影视</strong>与<strong className="text-background-300">高分电影</strong>，提供流畅<strong className="text-background-300">91精品视频在线播放</strong>体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '专题合集', href: '#index' },
                { label: '精选推荐', href: '#cards' },
                { label: '热门话题', href: '#topics' },
                { label: '热门榜单', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '精彩影评', href: '#media' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">服务支持</h4>
            <div className="space-y-2.5">
              {[
                { label: '关于我们', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '移动客户端', href: '#app' },
                { label: '用户评价', href: '#comments' },
                { label: '平台特色', href: '#features' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              我们正在积极拓展合作伙伴关系，欢迎优质影视内容平台与我们联系共创。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 91在线视频. 本站内容仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <span className="whitespace-nowrap">91精品视频在线</span>
              <span className="whitespace-nowrap">91精品视频在线播放</span>
              <span className="whitespace-nowrap">精品影视高清播放</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}